import {Button} from "@nextui-org/react"; 
import {useNavigate} from "react-router-dom"; 
const Hero = ({className})=>{
  const navigate = useNavigate(); 
  const redirectSignup = ()=>{
	 navigate("/signup"); 
  }
  return (
	 <>
		<div>
		  <div className = {`${className ? className:"" } flex justify-center`}> 
			 <h1 className = "text-center text-[1.5rem] py-[2rem] p-[0.5rem] sm:text-[2.3rem] md:text-[2.8reting Evolved Through Insightto Investing Evolved Through Insight]"> Crypto Investment Made Simple </h1>
		  </div>
		  <div className = "flex justify-center">
			 <Button className = "font-bold" size = "lg" variant="ghost" color ="primary" onClick = {redirectSignup}> Get Started </Button>
		  </div>
		</div>
	 </>
  )
}
export default Hero; 

